import { wait } from './machine/helpers';
import { GameState, gameStates } from './machine/state-types';

export const state: GameState = {
    name: gameStates.cashReelsDouble,
    onEnter: async setState => {
        await wait(500);
        setState(gameStates.cashReels);
    },
    onExit: () => {}
};
